import { Component, OnInit, } from '@angular/core';
import { Router } from '@angular/router';
import { DefineBootboxId } from 'app/resources/classes/define-bootbox-id';
import { Headers } from '@angular/http';
import { MainService, PagamentoService } from 'app/resources/services/index';
import { MoedaUtils } from 'app/resources/utils/moeda-utils';
import { EnumTipoBoleto } from 'app/resources/enum/enumTipoBoleto';
import { ResponseCIP } from 'app/resources/models/ResponseCIP';
import { RequestPagamento } from 'app/resources/models/RequestPagamento';
import { EnumStatusBoleto } from 'app/resources/enum/enumStatusBoleto';

@Component({
  selector: 'app-novo-pagamento-individual',
  templateUrl: './novo-pagamento-individual.component.html',
})

export class NovoPagamentoIndividualComponent implements OnInit {

  private readonly TEXTO_INICIAL_DESCRICAO = 'Descrição do pagamento'
  public readonly enumTipoBoleto = EnumTipoBoleto;
  public readonly enumStatusBoleto = EnumStatusBoleto;
  public inputLinhaDigitavel = '';
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public ep: string;
  public inputDescricao: string;

  constructor(public mainService: MainService, public pagamentoService: PagamentoService, public router: Router) { }

  ngOnInit() {
    this.ep = '';
    window.scrollTo(0, 0);
    this.deletePagamento();
  }
  public deletePagamento() {
    this.mainService.pagamentoService.pagamentoIndividual = '';
    this.inputLinhaDigitavel = '';
  }

  public calculaTotais() {
    this.mainService.pagamentoService.calculaTotais();
  }

  public validatePagamento() {
    const linhaDigitavel = this.clearCaracteresEspeciais(this.inputLinhaDigitavel);
    if (linhaDigitavel) {
      this.mainService.pagamentoService.pagamentoIndividual = this.setLinhaDigitavelPagamento(linhaDigitavel);
      this.mainService.pagamentoService.validatePagamentoIndividual()
    }
  }

  private clearCaracteresEspeciais(item: string) {
    if (item) {
      return item.replace(/[^0-9]/g, '');
    }
  }

  private setLinhaDigitavelPagamento(linhaDigitavel: string): ResponseCIP {
    return {
      status: '',
      message: '',
      valuePoints: null,
      observacao: '',
      isEditing: false,
      barcodeDetails: {
        bankCode: '',
        bankName: '',
        barcode: '',
        digitableLine: this.clearCaracteresEspeciais(linhaDigitavel),
        dueDate: '',
        value: null,
        type: ''
      },
      paymentInfo: {
        recipientDocument: '',
        recipientName: '',
        payerDocument: '',
        payerName: '',
        dueDate: '',
        limitDate: null,
        minValue: null,
        maxValue: null,
        fineValue: null,
        interestValue: null,
        originalValue: null,
        totalUpdatedValue: null,
        totalDiscountValue: null,
        totalAdditionalValue: null
      }
    }
  }

  public getStatusFormatado(status: string): string {
    return status ? status.replace('_', ' ') : '';
  }

  public applyConversion(): number {
    return MoedaUtils.pontoToMoeda(this.mainService.pagamentoService.valotTotalBoletos, this.mainService.cartaoService.cartao.indiceMoeda);
  }

  public clearTextoInicialDescricao() {
    if (this.mainService.pagamentoService.pagamentoIndividual.observacao === this.TEXTO_INICIAL_DESCRICAO) {
      this.mainService.pagamentoService.pagamentoIndividual.observacao = '';
    }
  }

  private isPagamentoInvalido() {
    return this.mainService.pagamentoService.pagamentoIndividual.status !== EnumStatusBoleto.NAO_PAGO
  }

  public setBoletoParaPagamento(ticket: ResponseCIP): RequestPagamento {
    const validatedValorMoeda = ticket.paymentInfo && ticket.paymentInfo.totalUpdatedValue ? ticket.paymentInfo.totalUpdatedValue : ticket.barcodeDetails.value;
    return {
      valorMoeda: validatedValorMoeda,
      vencimento: ticket.paymentInfo.dueDate,
      destinatario: ticket.paymentInfo.recipientName,
      documento: this.clearCaracteresEspeciais(ticket.paymentInfo.recipientDocument),
      beneficiarioDocumento: ticket.paymentInfo.payerDocument,
      banco: ticket.barcodeDetails.bankName,
      linhaDigitavel: ticket.barcodeDetails.digitableLine,
      tipo: this.setTipoBoleto(ticket),
      valorDescontoMoeda: ticket.paymentInfo.totalDiscountValue,
      observacao: ticket.observacao
    }
  }

  private setTipoBoleto(ticket: ResponseCIP): string {
    if (ticket.barcodeDetails.type === this.enumTipoBoleto.SIMPLES) {
      return this.enumTipoBoleto.boleto
    } else if (ticket.barcodeDetails.type === this.enumTipoBoleto.ARRECADACAO) {
      return this.enumTipoBoleto.conta_consumo
    }
  }

  public payBoleto() {
    if (this.isPagamentoInvalido()) {
      return this.bootboxAlertComId.alerta('Boleto inválido para pagamentos!')
    }

    this.clearTextoInicialDescricao();
    if (!this.mainService.pagamentoService.pagamentoIndividual.observacao) {
      return this.bootboxAlertComId.alerta('Preencha o campo descrição!');
    }

    this.mainService.pagamentoService.processando = true;
    const boleto = this.setBoletoParaPagamento(this.mainService.pagamentoService.pagamentoIndividual)

    const cabecalho: Headers = new Headers();
    cabecalho.append('Authorization', 'Basic ' + this.mainService.sessionService.getAuthBasic());
    cabecalho.append('X-Auth-Ep', this.ep);
    this.mainService.http.pathRest()
      .post('cartao/pagamento/', boleto, true, cabecalho)
      .subscribe(
        sucesso => {
          this.mainService.saldoService.initialize();
          this.deletePagamento();
          this.mainService.pagamentoService.processando = false;
          this.router.navigate(['/pagamentos']);
          this.bootboxAlertComId.alerta('O pagamentos foram realizados com sucesso!');
        }, erro => {
          this.mainService.pagamentoService.processando = false;
          this.bootboxAlertComId.alerta(erro.text());
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/pagamento/novo-pagamento-individual/novo-pagamento-individual.component.ts